import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../../../store/actions';
import i18n from '../../../i18n';

const LogoutButton = () => {
  const { isAuthenticated, logout } = useAuth0();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isAuthenticated) {
      localStorage.clear();
      sessionStorage.clear();
      dispatch(logoutUser(navigate));
    }
  }, [isAuthenticated, dispatch, navigate]);

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
    dispatch(logoutUser(navigate));
  };

  return isAuthenticated ? (
    <a className="dropdown-item" onClick={handleLogout}>
      <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
      {i18n.t("Logout")}
    </a>
  ) : null;
};

export default LogoutButton;
